module.exports = __webpack_public_path__ + "img/featured-old.18158ac1.jpg";